import { AppBar, ButtonBase, IconButton, Toolbar, useMediaQuery } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { ReactComponent as LogoWithTextSVG } from '~/assets/img/logo-with-text.svg';
import { AppNavList } from '~/common/nav-list';
import { toggleNawDrawerAction } from '~/features/dashboard/store/actions';
import { mediaQuery } from '~/styles/media-query';
import { useAppRoute } from '~/utils/hooks/useAppRoute';
import css from './styles.module.scss';

export const AppHeader: React.FC = () => {
    const route = useAppRoute();
    const dispatch = useDispatch();

    const goToHome = useCallback(() => {
        route('/');
    }, [route]);

    const isDesktop = useMediaQuery(mediaQuery.desktop);

    const handleToggleDrawer = useCallback(() => {
        dispatch(toggleNawDrawerAction());
    }, [dispatch]);

    return (
        <AppBar className={css.appBar} position={'sticky'}>
            <Toolbar className={css.toolBar}>
                {!isDesktop && (
                    <IconButton aria-label="open drawer" onClick={handleToggleDrawer} edge="start" className={classNames(css.menuButton)}>
                        <MenuIcon />
                    </IconButton>
                )}
                <ButtonBase className={css.headerLogo} onClick={goToHome}>
                    <LogoWithTextSVG />
                </ButtonBase>

                {isDesktop && <AppNavList />}
            </Toolbar>
        </AppBar>
    );
};
